<div *ngIf="pricing != null && expanded" class="pricing-update-content">
    <strong>Nye priser fra 2022</strong>
    <p>
        Lodpriserne justeres fra april 2022.
    </p>
    <div class="pricing-update-content-months">
        <span class="pricing-update-content-months-label"><strong>Gammel pris:</strong> {{ pricing.current.months }}:</span>
        <span class="pricing-update-content-months-value">{{ pricing.current.price | money }} pr. md.</span>
    </div>
    <div class="pricing-update-content-months">
        <span class="pricing-update-content-months-label"><strong>Ny pris:</strong> {{ pricing.updated.months }}:</span>
        <span class="pricing-update-content-months-value">{{ pricing.updated.price | money }} pr. md.</span>
    </div>
</div>
